/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */
import { ClearableSearchField } from "components/SearchField/SearchField";
import {
  Button,
  Card,
  CardContent,
  FormControl,
  Grid,
  InputAdornment,
  InputLabel,
  MenuItem,
  Select,
  Tooltip,
  styled,
  tooltipClasses,
} from "@mui/material";
import { GridSearchIcon } from "@mui/x-data-grid";
import { BTable } from "components/BTable/BTable";
import { getColorMappings } from "components/ColorComponent/ColorComponent";
import TimelineItem from "components/Icon/TimelineItem";
import MDButton from "components/MDButton";
import ViewDocument from "components/ViewDocumentModal/viewDocument";
import DeleteConfirmationDialog from "components/DeleteConfirmationDialog/DeleteConfirmationDialog";
import { useMaterialUIController } from "context";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import PageTitle from "examples/PageTitle/PageTitle";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { Link } from "react-router-dom";
import { deleteinvoiceReminder, fetchInvoiceReminderTemplate } from "utils/api";
import { appConstants } from "utils/appConstants";
import { getScreenRight, showResMsg } from "utils/generic";
import { genericMessage } from "utils/genericMessages";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconMenu from "components/CustomMaterialMenu/Custom";
let searchParameter = "";
let Status = "All";
let LOGIN_DETAILS;

const CustomWidthTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))({
  [`& .${tooltipClasses.tooltip}`]: {
    maxWidth: 500,
  },
});

function InvoiceReminderTemplate() {
  const [customerReload, setCustomerReload] = useState(false);
  const [showProfileModalFlag, setShowProfileModalFlag] = useState(false);
  const [screenPermission, setScreenPermission] = useState(false);
  const [rows, setRows] = useState([]);
  const [controller] = useMaterialUIController();
  const { darkMode, sidenavColor } = controller;
  const { barColor } = getColorMappings(sidenavColor);
  const [deleteDialogeFlag, setDeleteDialogeFlag] = useState(false);
  const [title, setTitle] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [file, setFile] = useState();
  const dispatch = useDispatch();
  const [values, setValues] = React.useState({
    _id: [],
    userType: "",
    sortingType: "",
    sortingField: "",
    page: appConstants.page,
    limit: appConstants.limit,
    filterValues: "",
    searchParameter: "",
    Status: "All",
    searchParameterList: [
      "reminderTemplateName",
      "Status",
      "reminderType",
      "legalDocumentStatus",
      "legalDocumentRemarks",
    ],
    businessUserID: JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"))
      ?.businessUserID,
  });

  if (
    sessionStorage.getItem("LOGIN_DETAILS") !== undefined &&
    sessionStorage.getItem("LOGIN_DETAILS") != null
  ) {
    LOGIN_DETAILS = JSON.parse(sessionStorage.getItem("LOGIN_DETAILS"));
    values.businessUserID = LOGIN_DETAILS.businessUserID;
  }

  useEffect(() => {
    (async () => {
      await getRight();
      await fetchUserReminderData();
    })();
  }, [values.Status, values.sortingType, perPage, dispatch]);

  useEffect(() => {
    Status = values.Status;
    changeCustomerReload();
  }, [values.Status]);

  const handleSearchFilter = (event) => {
    setValues({ ...values, filterValues: event.target.value });
  };

  const handlePageChange = (page) => {
    values.page = page;
    fetchUserReminderData();
  };

  const handlePerRowsChange = async (newPerPage, page) => {
    values.page = page;
    values.limit = newPerPage;
    setPerPage(newPerPage);
  };

  const handleSort = async (type, value) => {
    values.sortingType = value;
    values.sortingField = type;
  };

  const changeCustomerReload = () => {
    setCustomerReload(!customerReload);
  };

  async function getRight() {
    let right = await getScreenRight("Invoice Reminder Templates");
    console.log("aaa", right);
    if (right === "Full Access") {
      setScreenPermission(true);
    } else setScreenPermission(false);
  }

  const handleCancel = (name) => (event) => {
    // setSelectedRows([]);
    setDeleteDialogeFlag(false);
  };

  const handleDeleteDialogeClick = async (_id) => {
    values._id = _id;
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const handleDelete = async (id) => {
    deleteReminder();
    setDeleteDialogeFlag(!deleteDialogeFlag);
  };

  const deleteReminder = async () => {
    await deleteinvoiceReminder(
      values,
      (data) => {
        fetchUserReminderData();
        setTitle("");
        showResMsg(
          data.Result_Status ? genericMessage.deleted : data.Result_Message,
          1000,
          data.Result_Status
        );
      },
      dispatch
    );
  };

  const fetchUserReminderData = async () => {
    values.searchParameter = searchParameter;
    values.Status = Status;
    await fetchInvoiceReminderTemplate(
      values,
      (data) => {
        setTotalRows(data.Result_Output.totalDocs);
        setRows(data.Result_Output.docs);
      },
      dispatch
    );
  };

  const handleCancelDoc = (name) => (event) => {
    setShowProfileModalFlag(false);
  };

  let columns = [
    {
      // name: "Reminder Template Name",
      name: <p style={{ fontSize: "12px" }}>Reminder Template Name</p>,
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.reminderTemplateName}</span>
      ),
      sortable: true,
      sortField: "reminderTemplateName",
      style: { paddingleft: "10px" },
    },
    {
      // name: "Reminder Type & Days ",
      name: (
        <p style={{ paddingLeft: "20px", fontSize: "12px" }}>
          Reminder Type & Days
        </p>
      ),
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.reminderType}</span>
      ),
      sortable: true,
      sortField: "reminderType",
      center: "true",
    },
    {
      // name: "Legal Document Uploaded",
      name: (
        <p style={{ paddingLeft: "20px", fontSize: "12px" }}>
          Legal Document Uploaded
        </p>
      ),
      selector: (row) => (
        <span style={{ fontSize: "12px" }}>{row.legalDocumentStatus}</span>
      ),
      sortable: true,
      sortField: "legalDocumentStatus",
      center: "true",
    },
    {
      // name: "Legal Document Remarks",
      name: (
        <p style={{ paddingLeft: "20px", fontSize: "12px" }}>
          Legal Document Remarks
        </p>
      ),
      cell: (row) => (
        <CustomWidthTooltip title={row.legalDocumentRemarks}>
          <span
            style={{
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
              paddingRight: "30px",
              fontSize: "12px",
            }}
          >
            {row.legalDocumentRemarks}
          </span>
        </CustomWidthTooltip>
      ),
      sortable: true,
      sortField: "legalDocumentRemarks",
      center: true,
      width: "300px",
      style: {
        whiteSpace: "nowrap",
        overflow: "hidden",
        textOverflow: "ellipsis",
      },
    },
    {
      // name: "Status",
      name: <p style={{ paddingLeft: "15px", fontSize: "12px" }}>Status</p>,
      selector: (row) => <span style={{ fontSize: "12px" }}>{row.Status}</span>,
      sortable: true,
      sortField: "Status",
      center: "true",
    },
    {
      // name: "Actions",
      name: <p style={{ fontSize: "12px" }}>Action(s)</p>,
      selector: (row) => <span style={{ fontSize: "12px" }}>{row._id}</span>,
      center: "true",
      cell: (row) => (
        <IconMenu
          size="small"
          row={
            <>
              {/* <Grid container justifyContent={"center"} mr={2} spacing={4} mt={-6.2}> */}
              <Grid style={{ width: "100%" }} item>
                {screenPermission ? (
                  <Link to={`/invoiceReminderTemplate/edit/${row._id}`}>
                    <p
                      style={darkMode ? { color: "white" } : { color: "black" }}
                    >
                      <TimelineItem
                        color="success"
                        // icon="edit"
                        icon={<EditIcon className="actionicon" />}
                        title="Edit"
                      />
                      &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit
                    </p>
                  </Link>
                ) : (
                  <p style={darkMode ? { color: "white" } : { color: "black" }}>
                    <TimelineItem
                      color="grey"
                      // icon="edit"
                      icon={<EditIcon className="actionicon" />}
                      title="Edit"
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Edit
                  </p>
                )}
              </Grid>
              <Grid style={{ width: "100%" }} item>
                {screenPermission ? (
                  <p
                    style={darkMode ? { color: "white" } : { color: "black" }}
                    data-clickable="true"
                    onClick={() => handleDeleteDialogeClick(row._id)}
                  >
                    <TimelineItem
                      color="error"
                      // icon="delete"
                      icon={<DeleteIcon className="actionicon" />}
                      title="Delete"
                      onClick={() => handleDeleteDialogeClick(row._id)}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete
                  </p>
                ) : (
                  <p style={darkMode ? { color: "white" } : { color: "black" }}>
                    <TimelineItem
                      color="grey"
                      //  icon="delete"
                      icon={<DeleteIcon className="actionicon" />}
                      title="Delete"
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Delete
                  </p>
                )}
              </Grid>
            </>
          }
        />
      ),
    },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <div style={{ marginTop: "20px" }}>
        <Card color="primary">
          <PageTitle screenName="Invoice Reminder Templates" />
          <Grid
            container
            display={"flex"}
            justifyContent="end"
            mt={2.2}
            gap={2}
          >
            <Grid lg={2.5} xs={6}>
              <FormControl fullWidth>
                <InputLabel id="Status">Filter By Status</InputLabel>
                <Select
                  labelId="demo-simple-select-label"
                  id="demo-simple-select"
                  style={{ height: "38.11px" }}
                  label="Filter By Status"
                  value={values.Status}
                  onChange={(e) =>
                    setValues({ ...values, Status: e.target.value })
                  }
                >
                  <MenuItem value="All">All</MenuItem>
                  <MenuItem value="Active">Active</MenuItem>
                  <MenuItem value="Inactive">Inactive</MenuItem>
                </Select>
              </FormControl>
            </Grid>
            <Grid lg={2.5} xs={6}>
              <ClearableSearchField
                type="text"
                variant="outlined"
                fullWidth
                className="searchButton"
                placeholder="Search..."
                label="Search Filter"
                value={values.filterValues}
                onChange={handleSearchFilter}
                onKeyUp={(e) => {
                  if (e.key === "Enter") fetchUserReminderData();
                }}
                InputProps={{
                  endAdornment: (
                    <InputAdornment>
                      <Button
                        style={{
                          borderRadius: "0px 0.5rem  0.5rem 0px",
                          boxShadow: "none",
                          background: barColor,
                        }}
                        variant="contained"
                        onClick={fetchUserReminderData}
                      >
                        <GridSearchIcon color="white" />
                      </Button>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>
            <div style={{ marginRight: "16px" }}>
              {screenPermission ? (
                <>
                  <Link to={"/invoiceReminderTemplate/new"}>
                    <MDButton
                      variant="contained"
                      className={
                        "btn-block center-container-btn btn-warning btn-back rightSpace"
                      }
                      color="success"
                      style={{ height: "38.11px" }}
                    >
                      Add New
                    </MDButton>
                  </Link>
                </>
              ) : (
                <MDButton
                  variant="contained"
                  className={
                    "btn-block center-container-btn btn-warning btn-back rightSpace"
                  }
                  color="secondary"
                >
                  Add New
                </MDButton>
              )}
            </div>
          </Grid>
          {/* <CardContent> */}
          <BTable
            // title={title}
            columns={columns}
            data={rows}
            sortingType={handleSort}
            sortServer
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangeRowsPerPage={handlePerRowsChange}
            onChangePage={handlePageChange}
            fixedHeaderScrollHeight="410px"
            fixedHeader={true}
          />
          {/* </CardContent> */}
        </Card>
      </div>
      <DeleteConfirmationDialog
        open={deleteDialogeFlag}
        handleDelete={handleDelete}
        handleCancel={handleCancel("handleCancel")}
        closeModalClick={handleCancel("closeModalClick")}
      />
      {/* <LoadingModal loading={loading} /> */}

      <ViewDocument
        open={showProfileModalFlag}
        fileName={file}
        closeModalClick={handleCancelDoc("closeModalClick")}
      />
    </DashboardLayout>
  );
}

export default InvoiceReminderTemplate;
